<script>
import { MainMenu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        items: []
      },
      singleton: true,
      redirectRoute: null
    }
  },
  computed: {
    service() {
      return MainMenu
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Header({
          text: 'Grupy menu'
        }),
        new fields.Formset({
          blankObject: { links: [] },
          modelPath: [this, 'form', 'items'],
          items: this.form.items.map((item, i) => {
            return {
              headerLabel: get(item, ['label_pl']),
              fields: [
                new fields.Input({
                  label: 'Nagłówek',
                  modelPath: [this, 'form', 'items', i, 'label'],
                  required: true,
                  multilingual: true
                }),
                new fields.Header({
                  type: 'h4',
                  text: 'Odnośniki'
                }),
                this.getLinksFormset(this.form.items[i].links, i)
              ]
            }
          })
        })
      ]
    },
    getLinksFormset(links, itemIndex) {
      return new fields.Formset({
        modelPath: [this, 'form', 'items', itemIndex, 'links'],
        items: links.map((link, linkIndex) => {
          return {
            headerLabel: get(link, ['label_pl']),
            fields: [
              new fields.Link({
                label: 'Link',
                modelPath: [
                  this,
                  'form',
                  'items',
                  itemIndex,
                  'links',
                  linkIndex
                ],
                showIconInput: true
              })
            ]
          }
        })
      })
    }
  }
}
</script>
